exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".c-pb-boosters-modal-table{color:#112363}.c-pb-boosters-modal-table>.row{margin-top:10px}", ""]);

// exports
